module.exports = __webpack_public_path__ + "img/banner-2-mobile.c6f6cc18.webp";